const ADMIN_OLD_CAMPAIGNS = {
  SET_OLD_CAMPAIGNS_QUERY: 'SET_OLD_CAMPAIGNS_QUERY',
  SET_CAMPAIGN_VIEW_DATA: 'SET_CAMPAIGN_VIEW_DATA',
};

export default ADMIN_OLD_CAMPAIGNS;
